module.exports = __webpack_public_path__ + "3738c24570ec0a92a000ba78665f50a1.MP3";